<template>
  <div class="card">
    <div class="card-header text-white bg-dark" :id="`${id}Header`">
      <div class="row justify-content-between">
        <div class="col">
          <h5 class="mt-1">{{ title }}</h5>
        </div>
        <div v-if="active" class="col-4 align-self-center">
          <div style="background-color: #faa725; border-radius: 3px" class="text-center">
            <i class="fa fa-play" /> En cours
          </div>
        </div>
        <button
          data-toggle="collapse"
          :data-target="`#${id}`"
          type="button"
          class="collapsed col-2 btn btn-primary"
          :aria-expanded="expanded"
          :aria-controls="id"
        >
          <i class="fa fa-chevron-up pull-right" />
          <i class="fa fa-chevron-down pull-right" />
        </button>
      </div>
    </div>
    <div
      :class="`collapse ${expanded === 'true' ? 'show' : ''}`"
      :id="id"
      :data-parent="`#${accordionName}`"
      :aria-labelledby="`${id}Header`"
    >
      <div class="card-body container">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordionCard',
  props: {
    title: { type: String, default: '' },
    id: { type: String, default: '' },
    accordionName: { type: String, default: '' },
    expanded: { type: String, default: 'false' },
    active: Boolean,
  },
};
</script>

<style scoped>
button[aria-expanded="false"] .fa-chevron-up {
  display: none;
}
button[aria-expanded="true"] .fa-chevron-down {
  display: none;
}
</style>
